/* 🤖 this file was generated by svg-to-ts */
export const matIconLinearScale: {
  name: 'linear-scale';
  data: string;
} = {
  name: 'linear-scale',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 0 0 0 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 0 0 0-5z"/></svg>`
};
